import { useCallback, useEffect, useState } from 'react';
import api from '../../../services/api';

// PM analitik P7b — E19 çalışan tarafı (Dönem Sonuçlarım). Uçlar YALNIZ dönem kimliği alır; kişi oturumdan çözülür (başka kişi
// parametresi yoktur):
//   GET  v1/performance-experience/my/{periodId}          → durum (yayım, sürüm, görüşme, teyit, anket)
//   POST v1/performance-experience/my/{periodId}/confirm  → "Görüşmeyi Yaptık" (güncel sonuç sürümüne bağlı; puan kabulü DEĞİL)
//   POST v1/performance-experience/my/{periodId}/survey   → 3 soruluk anonim deneyim anketi (tek gönderim)
// GET başarısızsa (abonelik/dönem yok) kart hiç görünmez — sonuç sayfasının kendi boş durumu yeterlidir (skipErrorToast).
const BASE = '/v1/performance-experience/my';

export const SURVEY_QUESTIONS = ['clarity', 'fairness', 'usefulness'];
export const NOT_APPLICABLE = 'na';

export function useMyExperience(periodId) {
  const [state, setState] = useState({ loading: false, data: null });
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    if (!periodId) { setState({ loading: false, data: null }); return undefined; }
    let cancelled = false;
    setState((s) => ({ ...s, loading: true }));
    api.get(`${BASE}/${periodId}`, { skipErrorToast: true })
      .then((res) => { if (!cancelled) setState({ loading: false, data: res?.data?.status ? res.data.data : null }); })
      .catch(() => { if (!cancelled) setState({ loading: false, data: null }); });
    return () => { cancelled = true; };
  }, [periodId, refresh]);

  const reload = useCallback(() => setRefresh((r) => r + 1), []);

  // Mutasyon hataları interceptor'da uyarılır; burada yalnız sonuç döner.
  const confirm = useCallback(async () => {
    try {
      const res = await api.post(`${BASE}/${periodId}/confirm`);
      if (res?.data?.status) reload();
      return !!res?.data?.status;
    } catch {
      return false;
    }
  }, [periodId, reload]);

  const submitSurvey = useCallback(async (values) => {
    const body = {};
    SURVEY_QUESTIONS.forEach((q) => {
      const v = values?.[q];
      body[q] = v && v !== NOT_APPLICABLE ? Number(v) : null;
    });
    try {
      const res = await api.post(`${BASE}/${periodId}/survey`, body);
      if (res?.data?.status) reload();
      return !!res?.data?.status;
    } catch {
      return false;
    }
  }, [periodId, reload]);

  return { ...state, confirm, submitSurvey, reload };
}
